const styles = theme => ({
  root: {
    marginTop:0,
    marginBottom: 60,
    flexGrow:1,
    [theme.breakpoints.up('sm')]: {
        marginTop:0,
    },
    [theme.breakpoints.up('md')]: {
        marginTop:0,
    },
  },
  flex: {
    flex: 1,
    marginTop: -8,
    fontSize: 15,
    marginLeft: 10,
    [theme.breakpoints.up('sm')]: {
      marginTop: -13,
      fontSize: 18,
    },
    [theme.breakpoints.up('md')]: {
        marginTop: -13,
        fontSize: 18,
    },
  },
  iconRight: {
    position:'fixed',
    zIndex: 5000,
    fontSize: 24,
    marginTop: -64,
    marginLeft:'calc(100% - 65px)',
    [theme.breakpoints.up('sm')]: {
      marginTop: -64,
      marginLeft:'calc(100% - 67px)',
      fontSize: 24,
    },
    [theme.breakpoints.up('md')]: {
        marginTop: -64,
        marginLeft:'calc(100% - 337px)',
        fontSize: 24,
    },
  },
  appBar: {
    marginTop:63,
    zIndex: 500,
    marginLeft: 0,
    width: '50%',
    paddingTop:0,
    width: '100%',
    height: 45,
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2px 2px',
    color:"rgba(255, 255, 255, 1)",
    backgroundColor: "rgba(61, 136, 222, 1)",
    [theme.breakpoints.up('sm')]: {
        width: '100%',
        marginTop:70,
        height:50,
    },
    [theme.breakpoints.up('md')]: {
        width: 'calc(100% - 270px)',
        marginTop: 70,
        height: 50,
    },
  },
  backIcon: {
    fontSize: 30,
    marginTop: -8,
    marginLeft: -5,
    [theme.breakpoints.up('sm')]: {
      marginLeft: -4,
      marginTop: -10,
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: -22,
      marginTop: -10,
    },
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/User/components/Header/styles.js